import gql from 'graphql-tag'

export const WITH_CONTENT_PAGE_QUERY = gql`
  query ContentPage($path: String!, $country: [String]!) {
    cfContentPageCollection(
      where: { path: $path, country_contains_all: $country }
      limit: 1
    ) {
      items {
        sys {
          id
        }
        path
        country
        title
        shortDescription
        navigationMenu
        metaTitle
        modulesCollection(limit: 15) {
          items {
            ... on CFTerms {
              sys {
                id
              }
              title
              slug
              country
              bodyCopy
            }
            ... on CFPromotion {
              sys {
                id
              }
              title
              heading
              image {
                url
                title
                description
              }
              shortDescription
              callToActionLabel
              callToActionAddress
            }
            ... on CFComparisonModule {
              comparisonModuleCollection(limit: 2) {
                items {
                  sys {
                    id
                  }
                  productName
                  heroImageSet {
                    description
                    master {
                      url
                    }
                  }
                  valuePropositions
                  callToAction {
                    sys {
                      id
                    }
                    url
                    title
                  }
                  utilityPanel {
                    heading
                    contentEntriesCollection {
                      items {
                        ... on CFFeaturedLink {
                          url
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
